module.exports = __webpack_public_path__ + "static/media/micro_vs_macro.f1e35bb5.webp";